module.exports = __webpack_public_path__ + "static/Mark_Birkhead-3ebd570a22c3776b3388c0ee88bbfed1.jpg";